// extracted by mini-css-extract-plugin
export default {"ribbon":"Ribbon__ribbon___g0V21Zui","ribbonNew":"Ribbon__ribbonNew___x4L3sohs","ribbonRenovating":"Ribbon__ribbonRenovating___M_mvaqG2","small":"Ribbon__small___S_gfqZkT"};